import React from 'react';
import {Stack, Typography, useTheme} from '@mui/material';
import {useNavigate, To} from 'react-router-dom';
import {useTranslate} from 'hooks';
import {FontIcon} from 'components';

interface BackButtonProps {
  path?: To;
  title?: string;
  showCloseIcon?: boolean;
  navigateBackOnClick?: boolean;
  onClick?: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({
  path,
  title,
  showCloseIcon,
  navigateBackOnClick = false,
  onClick,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const translate = useTranslate();
  return (
    <button
      style={{
        padding: 0,
        border: 'none',
        cursor: 'pointer',
        background: 'transparent',
        color: theme.palette.grey['700'],
      }}
      onClick={() => {
        if (path) navigate(path);
        if (onClick) onClick();
        if (navigateBackOnClick) navigate(-1);
      }}>
      <Stack
        spacing={1}
        direction={'row'}
        sx={{alignItems: 'center', justifyContent: 'center'}}
        role="button"
        aria-label={translate('common.back')}>
        <FontIcon icon={showCloseIcon ? 'xmark' : 'chevron-left'} size={'sm'} />
        <Typography variant={'body2'} sx={{fontWeight: 'bold', height: 24}}>
          {title ?? translate('common.back')}
        </Typography>
      </Stack>
    </button>
  );
};
